export enum Game {
  CS2 = 'cs2',
  DOTA = 'dota2',
}
